import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=ed471318&"
import script from "@/components/SideMenu/SideMenu.ts?vue&type=script&lang=ts&"
export * from "@/components/SideMenu/SideMenu.ts?vue&type=script&lang=ts&"
import style0 from "@/components/SideMenu/side-menu.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
